import { ChangeDetectorRef, Inject, inject, Component, OnInit } from '@angular/core';
import { CommonModule, ViewportScroller } from '@angular/common';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';
import {FormsModule} from '@angular/forms';

import { NotesService } from '../../services/notes/notes.service';
import { Note } from '../../services/model/note';
import { Paragraph } from '../../services/model/paragraph';

@Component({
  selector: 'app-home',
  imports: [FormsModule, CommonModule, RecaptchaModule],
  templateUrl: './home.html',
  styleUrl: './home.css'
})

export class Home implements OnInit{
  randNum : number;
  public notesFocus: Note;
  private _viewportScroller = inject(ViewportScroller);
  private activatedRoute = inject(ActivatedRoute);
  public activeImage: string;

  name = '';
  email='';
  captchaToken = '';

  siteKey = '6LcwYiEsAAAAAKNFXXwbMMRsFv11pvJX4PzYWLD8';
  showForm = true;


  constructor(private cdRef: ChangeDetectorRef, private notesService: NotesService) {
    this.notesFocus = new Note('','','','','',[new Paragraph('', '', 0, [''], '', '')]);
    this.randNum = 1;
    this.activeImage = '';
  }

  ngOnInit() {
     console.log('home')

    this.randNum = Math.floor(Math.random() * 3) + 1;    

    this.notesService.getNotes('home').subscribe(data => {
      this.notesFocus = data;
      this.cdRef.detectChanges();
    });
  }


  public submitForm(event: any): void { 

    let formSubmission = { 'body': {
        'firstname': this.name,
        'lastname': '',
        'email': this.email,
        'referral': '***Add to Email List***',
        'captchatoken' : this.captchaToken,
        'app' : 'tpdg'
      }
    };


    this.showForm = false;

    this.notesService.submitInquiry(JSON.stringify(formSubmission)).subscribe(data => {
      console.log('DONE: ')
      this.cdRef.detectChanges();

    });

  }

  onCaptchaResolved(token: any) {
    this.captchaToken = token;
  }

  formatTextArray(textArray: [string], imagePosition: string, imageSrc: string){
    let innerHTMLString = "";

    textArray.forEach(d => {
      innerHTMLString += d + "<br/>";
    })

    

    return innerHTMLString;
  }
  
  toggle(event: Event, src: string): void {
    // this.activeIndex = this.activeIndex === index ? null : index;
    console.log(event);
    this.activeImage = src;
    this.cdRef.detectChanges();

    // Access the clicked element
    const clickedElement = event.currentTarget as HTMLElement;
    console.log('Clicked element:', clickedElement);
    console.log('Element ID:', clickedElement.id); // Example: get the element's ID
    console.log(clickedElement.classList.contains('title-2'))
    // You can modify the element's properties if needed
    if(clickedElement.classList.contains('expand')){
      clickedElement.classList.remove('expand')
    } else {
      clickedElement.classList.add('expand')
    }
    
  }

  onScroll(event: Event) {
    const element = event.target as HTMLElement;
    const scrollLeft = element.scrollLeft;

    const scrollRightMax = element.scrollWidth - element.offsetWidth;

    let xx = document.getElementById('carousel-prev');
    let yy = document.getElementById('carousel-next');

    if(scrollLeft > 0) {
      xx?.classList.remove('hide-button');
    } else if(scrollLeft == 0 ){
      xx?.classList.add('hide-button');
    } 

     if(scrollLeft == scrollRightMax){
      yy?.classList.add('hide-button');
    } else {
      yy?.classList.remove('hide-button');
    }
  }

  next(event: Event, type: string) {
    let xx = document.getElementById(type);
    // console.log(xx?.scrollLeft)

    if(xx){
      let currentScroll = xx.scrollLeft;
       xx.scrollLeft += 500;

       console.log(currentScroll, xx.scrollLeft)
    }
    
  }

   previous(event: Event, type: string) {
    let xx = document.getElementById(type);
    // console.log(xx?.scrollLeft)

    if(xx){
      let currentScroll = xx.scrollLeft;
       xx.scrollLeft -= 500;

       // console.log(currentScroll, xx.scrollLeft)
    } 
  }  
  
}
